import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const LogoShort = ({ size = 24, className }: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      fill="none"
      height="32"
      viewBox="0 0 20 32"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.95392 29.9841L0 31.9982V13.0759C0 10.9733 1.16305 9.05088 3.00381 8.11344L7.19878 5.97656V24.6247C7.19878 26.8954 5.94278 28.9715 3.955 29.9841H3.95392Z"
        fill="url(#paint0_linear_1966_136555)"
      />
      <path
        d="M7.1982 18.3026L5.20935 15.9103C2.56115 12.7244 3.53828 7.84149 7.1982 5.97656V18.3026Z"
        fill="url(#paint1_linear_1966_136555)"
      />
      <path
        d="M7.19727 5.97656V18.3037L12.8006 26.0221V13.6728L7.19727 5.97656Z"
        fill="#95D9E5"
      />
      <path
        d="M17.4076 23.6748L12.8008 26.0217V7.37459C12.8008 5.10396 14.0568 3.02788 16.0446 2.01527L19.9996 0V19.3944C19.9996 21.2085 18.9965 22.8667 17.4086 23.6759L17.4076 23.6748Z"
        fill="url(#paint2_linear_1966_136555)"
      />
      <path
        d="M12.8008 26.0211V13.6719L14.7972 16.0807C17.4432 19.2722 16.4618 24.1551 12.8008 26.0211Z"
        fill="url(#paint3_linear_1966_136555)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_1966_136555"
          x1="3.60072"
          x2="3.60072"
          y1="5.97515"
          y2="31.9967"
        >
          <stop offset="0.14" stopColor="#95D9E5" />
          <stop offset="1" stopColor="#04ACF4" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_1966_136555"
          x1="5.45505"
          x2="5.45505"
          y1="18.3014"
          y2="5.97515"
        >
          <stop stopColor="#32BBEE" />
          <stop offset="1" stopColor="#4AC3EC" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_1966_136555"
          x1="16.4015"
          x2="16.4015"
          y1="-0.00141494"
          y2="26.0201"
        >
          <stop stopColor="#04ACF4" />
          <stop offset="0.935" stopColor="#95D9E5" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_1966_136555"
          x1="14.5511"
          x2="14.5511"
          y1="13.6724"
          y2="26.0224"
        >
          <stop stopColor="#32BBEE" />
          <stop offset="1" stopColor="#4AC3EC" />
        </linearGradient>
      </defs>
    </svg>
  </SvgIcon>
);
